import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    countryItem: CountryItem,
    setCountryHandler: (countryCode: string) => void,
};

const DropdownOptionItem: React.FC<Props> = ({ countryItem, setCountryHandler }) => {
    const theme: Theme = useTheme();

    const onClickHandler = () => {
        setCountryHandler(countryItem.code);
    };

    const style = css`
        white-space: nowrap;
        cursor: pointer;
        
        &:hover {
            color: ${theme.colours.curiousBlue};
        }
    `;

    return (
        <li css={style} onClick={onClickHandler}>{countryItem.name}</li>
    );
};

export default DropdownOptionItem;